// extracted by mini-css-extract-plugin
module.exports = {"badge":"FacetBadgeLabel_badge__szJkI","dark":"FacetBadgeLabel_dark__Y_PNd"};